









import Vue from "vue";
import TestCaseForm from "@/components/TestCaseForm.vue";
import cloneDeep from "lodash/cloneDeep";

function emptyTestCase() {
  return {
    title: "",
    description: "",
    steps: []
  };
}

export default Vue.extend({
  props: ["copyFrom", "testSuit"],
  components: {
    TestCaseForm
  },
  data: function() {
    let newTestCase;
    if (this.copyFrom) {
      newTestCase = cloneDeep(this.copyFrom);
    } else if (this.testSuit) {
      newTestCase = { ...emptyTestCase(), testSuitId: this.testSuit };
    } else {
      newTestCase = emptyTestCase();
    }
    return {
      newTestCase: newTestCase
    };
  },
  methods: {
    createTestCase(testCase: any) {
      this.$store.dispatch("createTestCase", testCase).then(() => {
        this.newTestCase = emptyTestCase();
        this.$router.push({ name: "testCases" });
      });
    }
  }
});
